import { captureException } from '@lib/error'
import { Linking } from 'react-native'

export async function openExternalLink(url: string): Promise<boolean> {
  return Linking.openURL(url)
    .then(() => true)
    .catch((error) => {
      captureException(error, 'openExternalLink')
      return false
    })
}
